import React from "react";
import { useLanguage } from "../i18n/LanguageContext";
import { legal } from "../i18n/legal";
import { LegalPage } from "../components/legal/LegalPage";
export function PrivacyPolicy() {
  const {
    lang
  } = useLanguage();
  return <LegalPage content={legal[lang].privacy} data-id="element-307" data-mp="qbuu7b2luy0h" />;
}